import { Component, input } from '@angular/core';
import type { OnyxAddress, OnyxAddressFormat } from '@onyx/angular';
import { OnyxAddressComponent } from '@onyx/angular';

@Component({
  selector: 'app-address-cell',
  imports: [OnyxAddressComponent],
  templateUrl: './address-cell.component.html',
  styleUrl: './address-cell.component.scss',
})
export class AddressCellComponent {
  public readonly address = input.required<OnyxAddress | null>();
  public readonly format = input.required<OnyxAddressFormat>();
  public readonly showFlag = input(true);
}
